import { useReducer, createContext } from 'react';

import { LoginPage } from './login-page';
import { hasApiToken, removeApiToken, storeApiToken } from '../../api-token';

export const LoginContext = createContext();

export function loginAction(token, expiresAt) {
    return { 
        type: "LOGIN", 
        value: {
            token,
            expiresAt,
        },
    };
}

export function logoutAction() {
    return { 
        type: "LOGOUT", 
        value: "",
    };
}

const loginReducer = (state, action) => {
    const { type, value } = action;

    if (type === "LOGIN") {
        const { token, expiresAt } = value;

        storeApiToken(token, expiresAt);

        return {
            loggedIn: true,
        };
    }

    if (type === "LOGOUT") {
        removeApiToken();

        return {
            loggedIn: false,
        };
    }

    return state;
};

function createInitialState() {
    const loggedIn = hasApiToken();

    return {
        loggedIn,
    };
}

export function LoginGate({ children }) {
    const [state, dispatch] = useReducer(loginReducer, createInitialState());

    if (state.loggedIn) {
        return (
            <LoginContext.Provider value={{ state, dispatch }}>
                {children}
            </LoginContext.Provider>
        );
    }

    return (
        <LoginContext.Provider value={{ state, dispatch }}>
            <LoginPage />
        </LoginContext.Provider>
    );
}